import React, { PureComponent } from 'react'
import Checkbox from '../../../../Shared/Form/Checkbox'
import './styles.scss'
import { getRoomName } from '../common'
import Alert from '../../../../Shared/Alert'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { addRoomToImageRelation, deleteRoomToImageRelation } from '../../../../../api'
import Loader from '../../../../Shared/Loader'
import activityTrackingService from '../../../../../services/activityTrackingService'
import { trackingEvent } from '../../../../../constants'
import TooltipWrapper from '../../../../Shared/TooltipWrapper'

class ImageRoomAssigner extends PureComponent {

  abortController = null
  state = {
    loading: false,
    error: null
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  onChange (desiredChecked, room) {
    if (desiredChecked) {
      activityTrackingService.trackEvent(trackingEvent.assignImageToRoom)
      this.addRoomToImageRelation(room)
    } else {
      this.deleteRoomToImageRelation(room)
    }
  }

  addRoomToImageRelation (room) {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()

    this.setState({ loading: true, error: null }, () => {
      const { fetchPromise } = addRoomToImageRelation(
        this.props.image.giataId,
        this.props.image.id, room.id,
        this.abortController
      )
      fetchPromise.then(() => {
        this.setState({ loading: false, error: null })
        if (this.props.galleries?.rooms?.[room.id]?.order?.includes(this.props.image.id)) {
          return
        }
        const newRoomGalleryOrder = [
          ...(this.props.galleries?.rooms?.[room.id]?.order ?? []),
          this.props.image.id,
        ]
        const newRoomGallery = {
          ...this.props.galleries?.rooms?.[room.id],
          order: newRoomGalleryOrder,
        }
        const newGalleries = {
          ...this.props.galleries,
          rooms: {
            ...this.props.galleries.rooms, [room.id]: {
              ...newRoomGallery,
            }
          }
        }
        this.props.onGalleriesChange(newGalleries, true)
      }).catch((e) => {
        console.error(e)
        this.setState({ loading: false, error: true })
      })
    })
  }

  deleteRoomToImageRelation (room) {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()

    this.setState({ loading: true, error: null }, () => {
      const { fetchPromise } = deleteRoomToImageRelation(
        this.props.image.giataId,
        this.props.image.id,
        room.id,
        this.abortController
      )
      fetchPromise.then(() => {
        this.setState({ loading: false, error: null })
        if (!this.props.galleries?.rooms?.[room.id]?.order?.includes(this.props.image.id)) {
          return
        }
        const newRoomGalleryOrder = this.props.galleries?.rooms?.[room.id]?.order?.filter(
          (imageId) => imageId !== this.props.image.id
        )
        const newRoomGallery = {
          ...this.props.galleries?.rooms?.[room.id],
          order: newRoomGalleryOrder,
        }
        const newGalleries = {
          ...this.props.galleries,
          rooms: {
            ...this.props.galleries.rooms,
            [room.id]: newRoomGallery,
          }
        }
        this.props.onGalleriesChange(newGalleries, true)
      }).catch((e) => {
        console.error(e)
        this.setState({ loading: false, error: true })
      })
    })
  }

  render () {
    const { t } = this.props
    const imageIsInPropertyGallery = this.props.galleries?.property?.order?.includes(this.props.image.id) ?? false

    let assignedRoomsMap = {}
    let numberOfAssignedRooms = 0
    Object.keys(this.props.galleries?.rooms ?? {}).forEach(roomId => {
      const order = this.props.galleries.rooms[roomId]?.order ?? []
      if (order.includes(this.props.image.id)) {
        assignedRoomsMap[roomId] = true
        numberOfAssignedRooms++
      }
    })

    return (
      <div className={'image-room-assigner'}>
        <h3>{t('ASSIGN_IMAGE_TO_ROOM')}</h3>
        {this.state.loading && <Loader size={32}/>}
        <div className={'image-to-room-container'}>
          {
            this.props.rooms.length === 0 &&
            <Alert type={'info'}>{t('NO_ROOMS_FOUND')}</Alert>
          }
          {this.state.error && <Alert type={'danger'}>Error occurred</Alert>}
          {this.props.rooms.map((room) => {
            const isDisabled = numberOfAssignedRooms === 1 && assignedRoomsMap[room.id] === true && !imageIsInPropertyGallery
            return (
              <div className={'image-to-room'} key={room.id}>
                <div className={'image-to-room-prepend'}>
                  <TooltipWrapper
                    content={t('images.imageUnassignmentNotAllowedTooltip')}
                    place="left"
                    positionStrategy="fixed"
                    hidden={!isDisabled}
                    maxWidth="200px"
                  >
                    <div>
                      <Checkbox
                        label={getRoomName(this.props.roomAttributes, room)}
                        disabled={isDisabled}
                        value={assignedRoomsMap.hasOwnProperty(room.id)}
                        onChange={(e) => this.onChange(e.target.checked, room)}
                      />
                    </div>
                  </TooltipWrapper>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

ImageRoomAssigner.propTypes = {
  image: PropTypes.object.isRequired,
  roomAttributes: PropTypes.object.isRequired,
  rooms: PropTypes.array.isRequired,
  onImageChanged: PropTypes.func.isRequired,
  onGalleriesChange: PropTypes.func.isRequired,
  galleries: PropTypes.object.isRequired,
}

export default withTranslation()(ImageRoomAssigner)
